export const text = {
  title: 'Harvest',
  description: 'Log and review what you harvested this week.',
  gardenSelectLabel: 'Garden',
  gardenSelectPlaceholder: 'Select a garden',
  addHarvest: 'Log harvest',
  quickAddTitle: 'Log a harvest',
  quickAddHint: 'Uses the garden selected above. Logged for today unless you change the date.',
  changeDate: 'Change date',
  useToday: 'Use today',
  logHarvest: 'Log',
  editHarvest: 'Edit harvest',
  deleteHarvest: 'Delete harvest',
  today: 'Today',
  noHarvestsDay: 'No harvests',
  noGardenSelected: 'Select a garden to view harvests.',
  noGardens: 'Create a garden first to log harvests.',
  emptyPlantsInGarden: 'This garden has no plants. Add plants in the garden planner first.',

  gardenFieldLabel: 'Garden',
  plantFieldLabel: 'Plant',
  plantFieldPlaceholder: 'Select a plant',
  dateFieldLabel: 'Date',
  measureTypeLabel: 'Measure by',
  measureQuantity: 'Quantity',
  measureWeight: 'Weight',
  amountFieldLabel: 'Amount',
  amountQuantityPlaceholder: 'e.g. 12',
  amountWeightPlaceholder: 'e.g. 250',
  weightUnitLabel: 'Unit',
  weightUnitG: 'g',
  weightUnitKg: 'kg',

  saveHarvest: 'Save harvest',
  deleteConfirmTitle: 'Delete harvest?',
  deleteConfirmBody: 'This harvest entry will be permanently removed.',
  editAction: 'Edit harvest',
  deleteAction: 'Delete harvest',
};
